import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface PromiseState {
  resolve: (value: boolean) => void
}

export const useConfirmPopup = (): [
  () => JSX.Element | null,
  (params: { message: string; title: string }) => Promise<boolean>
] => {
  const [promise, setPromise] = useState<PromiseState | null>(null);
  const [message, setErrorMessage] = useState('');
  const [title, setTitle] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const { t } = useTranslation();

  const confirm = ({
    message: msg,
    title: titleText,
  }: {
    message: string
    title: string
  }) => new Promise<boolean>((resolve) => {
    setShowPopup(true);
    setErrorMessage(msg);
    setTitle(titleText);
    setPromise({ resolve });
  });

  const handleClose = () => {
    setPromise(null);
    setShowPopup(false);
    setErrorMessage('');
    setTitle('');
  };

  const handleCancel = () => {
    promise?.resolve(false);
    handleClose();
  };

  const ConfirmationDialog = () => {
    if (!showPopup) return null;

    return (
      <div className="fixed inset-0 z-[10000] flex items-center justify-center bg-shell bg-opacity-20 backdrop-blur-md">
        <div className="relative w-full max-w-lg rounded-lg px-6 pb-6 pt-10 shadow-2xl bg-checkout-card-gradient">
          <div className="flex flex-col items-center text-center">
            <h1 className="mb-4 font-poppins text-[22.5px] font-bold text-[#ECEAED]">
              {title}
            </h1>
            <p className="mb-8 text-center font-poppins text-[14px] font-light leading-relaxed text-[#AAD0FD]">
              {message}
            </p>
            <div className="flex w-full flex-row gap-4">
              <button
                type="button"
                onClick={handleCancel}
                className=" flex-1 rounded-lg bg-[#FFDC30] px-4 py-3 font-medium text-[#0E122C] transition-all duration-200 hover:bg-[#FFDC30]/90"
              >
                {t('buttons.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return [ConfirmationDialog, confirm];
};
